import { render, staticRenderFns } from "./AccessTableRow.vue?vue&type=template&id=8bc8ea7e&"
import script from "./AccessTableRow.vue?vue&type=script&lang=js&"
export * from "./AccessTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports